import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import HomeStatsBand from "./HomeStatsBand";
import HomeAbout from "./HomeABout";
import HomeServices from "./HomeServices";
import Footer from "../ones/Footer";
import CallToAction from "../ones/CallToAction";

export default function HomeLanding() {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <HomeBanner1 />
        <HomeStatsBand />
        <HomeAbout />
        <HomeServices />
        <CallToAction />
        <Footer />
      </>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
